// CV work experience logic

import { normalizeFieldsFromSchema } from "../shared/fieldNormalization";
import {
  mapWorkTimelineToTableRows,
  workTimelineFromTableRows,
} from "../shared/tableFieldHelpers";
import { isSupportedUploadFile } from "../shared/uploadMime";

const required = (value) =>
  value && String(value).trim() ? null : "This field is required.";

const schema = {
  type: "cv_work_experience",
  title: "CV / Work Experience",
  groups: [{ id: "contact", label: "Contact" }],
  fields: [
    {
      key: "candidate_name",
      label: "Candidate Name",
      group: "contact",
      inputType: "text",
      required: true,
      validate: required,
    },
    { key: "email", label: "Email", group: "contact", inputType: "text" },
    { key: "phone", label: "Phone", group: "contact", inputType: "text" },
  ],
  table: {
    title: "Work History",
    columns: ["Company", "Position", "Start Date", "End Date"],
  },
};

const enrichExtractedJson = (extracted) => ({ ...(extracted || {}) });

const getLlmExtractionFields = () => {
  const keys = schema.fields.map((field) => field.key);
  keys.push("work_timeline");
  return keys;
};

const validateFieldValue = (key, value) => {
  const def = schema.fields.find((field) => field.key === key);
  if (!def || typeof def.validate !== "function") return null;
  return def.validate(value);
};

const normalizeExtractedJson = (extracted, rawText = "") => {
  const enriched = enrichExtractedJson(extracted, rawText);
  return normalizeFieldsFromSchema(schema, enriched, rawText);
};

const buildTableFromExtracted = (data) => {
  if (!Array.isArray(data?.work_timeline) || !data.work_timeline.length) {
    return null;
  }

  return {
    title: schema.table?.title || "Work History",
    columns: schema.table?.columns || [
      "Company",
      "Position",
      "Start Date",
      "End Date",
    ],
    rows: mapWorkTimelineToTableRows(data.work_timeline),
  };
};

const appendTableToExtractedJson = (obj, tableData) => {
  const next = { ...obj };
  if (tableData?.rows?.length) {
    next.work_timeline = workTimelineFromTableRows(tableData.rows);
  }
  return next;
};

export const cvWorkExperienceType = {
  key: "cv_work_experience",
  schema,
  getLlmExtractionFields,
  enrichExtractedJson,
  normalizeExtractedJson,
  validateFieldValue,
  isSupportedFile: isSupportedUploadFile,
  buildTableFromExtracted,
  appendTableToExtractedJson,
};
